"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-1s2i22-0"
})(["box-sizing:border-box;margin:1rem auto;max-width:100%;padding:1rem;", " p,li,a,button{font-size:1rem;}"], function (_ref) {
  var size = _ref.size;
  var width = 1170;
  if (size === 'small') width = 768;
  if (size === 'large') width = 1440;
  return {
    width: width
  };
});

exports["default"] = _default;